interface FunctionObject {
  [K: string]: (...arg: any[]) => any;
}

type TInferFunctionArgumentType<T extends Function> = T extends (arg: infer A) => any ? A : never;

type TInferMapperValues<T extends FunctionObject> = {
  [K in keyof T]: TInferFunctionArgumentType<T[K]>;
};

type TInferFunctionReturnType<T extends FunctionObject> = {
  [K in keyof T]: ReturnType<T[K]>;
};

export const mapToQuery = <T extends FunctionObject>(
  mapper: T,
  values: Partial<TInferMapperValues<T>>,
): TInferFunctionReturnType<T> => {
  const { filterType, ...v } = values;
  const queryValue = Object.entries(v).reduce((prev, [key, value]) => {
    const mapped = mapper[key](value, values);
    return { ...prev, [key]: mapped };
  }, {}) as TInferFunctionReturnType<T>;

  return queryValue;
};
